import { render, staticRenderFns } from "./PartnerReferral.vue?vue&type=template&id=4a933a2d&scoped=true&"
import script from "./PartnerReferral.vue?vue&type=script&lang=js&"
export * from "./PartnerReferral.vue?vue&type=script&lang=js&"
import style0 from "./PartnerReferral.vue?vue&type=style&index=0&id=4a933a2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a933a2d",
  null
  
)

export default component.exports